import { render } from "./SessionActivitiesTable.vue?vue&type=template&id=797e2e8f&scoped=true"
import script from "./SessionActivitiesTable.vue?vue&type=script&lang=js"
export * from "./SessionActivitiesTable.vue?vue&type=script&lang=js"

import "./SessionActivitiesTable.vue?vue&type=style&index=0&id=797e2e8f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797e2e8f"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QImg from 'quasar/src/components/img/QImg.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QTable,QTooltip,QMenu,QList,QItem,QItemSection,QCheckbox,QRadio,QTh,QTd,QSpinnerDots,QImg});qInstall(script, 'directives', {Ripple,ClosePopup});
